import { Components, Theme } from "@mui/material";

export const MuiFormControlLabel: Components<Theme>["MuiFormControlLabel"] = {
  styleOverrides: {
    label: ({ theme }) => ({
      color: theme.newColors.neutral.gray500,
      ...theme.typography.body3,
    }),
  },
};
